// src/contexts/WorkflowContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const WorkflowContext = createContext();

export const WorkflowProvider = ({ children }) => {
  const [workflows, setWorkflows] = useState({});
  const [tags, setTags] = useState({});
  const [selectedKeywords, setSelectedKeywords] = useState(new Set());
  const [searchTerm, setSearchTerm] = useState('');
  const [allKeywords, setAllKeywords] = useState(new Set());

  useEffect(() => {
    const loadData = async () => {
      try {
        const filesResponse = await fetch('/files.json');
        const tagsResponse = await fetch('/tags.json');
        
        if (!filesResponse.ok || !tagsResponse.ok) {
          throw new Error('Failed to fetch data');
        }
        
        const filesData = await filesResponse.json();
        const tagsData = await tagsResponse.json();
        
        setWorkflows(filesData);
        setTags(tagsData);
        
        // Extract all unique keywords from tags
// Extract all unique keywords from new three-dimension tags
const keywords = new Set();
Object.values(tagsData).forEach(workflowTags => {
  if (workflowTags && typeof workflowTags === 'object') {
    // 遍历三个维度
    Object.values(workflowTags).forEach(dimensionTags => {
      if (Array.isArray(dimensionTags)) {
        dimensionTags.forEach(tag => keywords.add(tag));
      }
    });
  }
});
        
        setAllKeywords(keywords);
      } catch (error) {
        console.error('Error loading workflow data:', error);
        setAllKeywords(new Set(['laser', 'cutting', 'cnc', 'milling', '3d', 'printing', 'engraving']));
      }
    };

    loadData();
  }, []);

  const toggleKeyword = (keyword) => {
    setSelectedKeywords(prev => {
      const newSet = new Set(prev);
      if (newSet.has(keyword)) {
        newSet.delete(keyword);
      } else {
        newSet.add(keyword);
      }
      return newSet;
    });
  };

  const filterWorkflows = () => {
    const results = {};
    
    Object.entries(workflows).forEach(([category, files]) => {
      const filteredFiles = files.filter(file => {
        // Extract title from file name 
        const title = getName(file).toLowerCase();

const workflowTags = tags[file] || {};
// 将三维度标签展平为数组进行搜索
const allTags = [];
Object.values(workflowTags).forEach(dimensionTags => {
  if (Array.isArray(dimensionTags)) {
    allTags.push(...dimensionTags);
  }
});

const matchesSearch = !searchTerm || 
  title.includes(searchTerm.toLowerCase());

const matchesKeywords = selectedKeywords.size === 0 || 
  [...selectedKeywords].every(kw => allTags.includes(kw));
        return matchesSearch && matchesKeywords;
      });
      
      if (filteredFiles.length > 0) {
        results[category] = filteredFiles;
      }
    });
    
    return results;
  };
  
  // Helper function to get display name from file name
  const getName = (file) => {
    const name = file.split('_');
    name.shift();
    return name.join(' / ');
  };

  const value = {
    workflows,
    tags,
    allKeywords,
    selectedKeywords,
    searchTerm,
    setSearchTerm,
    toggleKeyword,
    filterWorkflows
  };

  return (
    <WorkflowContext.Provider value={value}>
      {children}
    </WorkflowContext.Provider>
  );
};

export const useWorkflows = () => {
  const context = useContext(WorkflowContext);
  if (!context) {
    throw new Error('useWorkflows must be used within a WorkflowProvider');
  }
  return context;
};
